export const TOKEN_SECRET = "$xd8%MdvYNA^";

export const IMG_BASE_URL = "https://api-wewell.dadekavweb.ir/";

export const PAGINATION_LIMIT_5 = 5;
export const PAGINATION_LIMIT_10 = 10;
export const PAGINATION_LIMIT = 16;
export const PAGINATION_LIMIT_15 = 15;
export const PAGINATION_LIMIT_21 = 21;
export const NEWS_PAGINATION_LIMIT = 4;
